import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getFuelMatchLanguage } from '../components/fuelmatch/languageDetection';

/**
 * Composant qui redirige depuis /fuelmatch vers la bonne page avec détection automatique de langue
 */
const FuelMatchRootRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Détecte la langue du navigateur
    const targetLang = getFuelMatchLanguage();
    const targetPath = `/backoffice/${targetLang}/home`;
    
    console.log('🌐 FuelMatchRootRedirect - Informations de redirection:');
    console.log('  - Langue du navigateur:', navigator.language);
    console.log('  - Langue détectée:', targetLang);
    console.log('  - URL cible:', targetPath);
    console.log('  - URL actuelle:', location.pathname);
    
    // Utilise navigate au lieu de Navigate pour éviter les boucles
    navigate(targetPath, { replace: true });
  }, [navigate, location.pathname]);

  // Affichage temporaire pendant la redirection
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif',
      color: '#07739b'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Backoffice</h2>
        <p>Redirection en cours...</p>
      </div>
    </div>
  );
};

export default FuelMatchRootRedirect;
